import { render, staticRenderFns } from "./AnsweredIcon.vue?vue&type=template&id=4c8a32e4&scoped=true"
import script from "./AnsweredIcon.vue?vue&type=script&lang=js"
export * from "./AnsweredIcon.vue?vue&type=script&lang=js"
import style0 from "./AnsweredIcon.vue?vue&type=style&index=0&id=4c8a32e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a32e4",
  null
  
)

export default component.exports